import { Alert } from '@seeqdev/qomponents';
import { useTranslation } from 'react-i18next';
import { EVIDENCE_LIMIT } from '@/vantage/constants';
import { formatNumber } from '@/utilities/numberHelper.utilities';

interface EvidenceLimitProps {
  evidenceCount: number | undefined;
}

export const EvidenceLimitWarning: React.FunctionComponent<EvidenceLimitProps> = ({ evidenceCount }) => {
  const { t } = useTranslation();
  if (!evidenceCount || (EVIDENCE_LIMIT as number) > evidenceCount) {
    return null;
  }
  return (
    <Alert dismissible={false} variant="warning">
      <div className="flexColumnContainer" data-testid="evidenceLimitWarningMessage">
        {t('VANTAGE.EVIDENCE_TABLE.EVIDENCE_LIMIT_EXCEEDED', {
          evidenceLimit: formatNumber(EVIDENCE_LIMIT, { format: '#,##0' }),
        })}
      </div>
    </Alert>
  );
};
